<template>
  <div class="header-preview">
    <div class="header-left">
      <img :src="logoSrc" alt="Logo" class="logo" />
    </div>
    <div class="header-right">
      <p class="report-title">RELATÓRIO: {{ reportNickname }}</p>
      <p>EMPRESA: {{ companyFantasyName }}</p>
      <p>EXPORTADO POR: {{ userDisplayName }}</p>
      <p>DATA DE EXPORTAÇÃO: {{ this.getDate() }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "HeaderPreview",
  props: {
    reportNickname: {
      type: String
    },
    logoSrc: {
      type: String,
      default: "/img/logo_tecnologia_azul.png"
    },
    companyFantasyName: {
      type: String
    },
    userDisplayName: {
      type: String
    }
  },
  data() {
    return {
      date: new Date()
    };
  },
  methods: {
    getDate() {
      const date = new Date();

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}`;

      return formattedDate;
    }
  }
};
</script>

<style scoped>
.header-preview {
  display: flex;
  height: inherit;
  justify-content: start;
  align-items: center;
  width: 100%;
}

p { 
    color: black;
}

.header-left {
  margin-right: 10px;
}

.header-right {
  display: flex;
  flex-direction: column;
}

.logo {
  width: 120px;
  height: auto;
}
</style>
